const services = [
  {
    icon: "ri-flashlight-line",
    title: "Emergency Passport",
    description: "24–72 hour processing for immediate departures from SRQ, TPA, or any Florida airport.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Passport Renewal",
    description: "Fast renewal for expired or soon-to-expire passports. No acceptance clerk needed.",
  },
  {
    icon: "ri-passport-line",
    title: "New Passport",
    description: "First-time passport with step-by-step guidance through the acceptance process in Sarasota or Manatee County.",
  },
  {
    icon: "ri-error-warning-line",
    title: "Lost or Stolen Passport",
    description: "Complete replacement service including DS-64 form and acceptance clerk support.",
  },
  {
    icon: "ri-parent-line",
    title: "Child Passport",
    description: "Passports for minors under 16 with parental consent documentation support.",
  },
  {
    icon: "ri-edit-line",
    title: "Name Change",
    description: "Passport update after marriage, divorce, or legal name changes.",
  },
  {
    icon: "ri-stack-line",
    title: "Second Passport",
    description: "Second valid passport for frequent international travelers and dual-visa needs.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Damaged Passport",
    description: "Replacement for water-damaged, torn, or otherwise compromised passports.",
  },
];

export default function LakewoodRanchServicesSection() {
  return (
    <section id="services" className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Our Services
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Services for Lakewood Ranch Travelers
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Comprehensive passport solutions for every situation — from first-time applications
            to emergency replacements before your flight from Sarasota-Bradenton International.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all hover:shadow-md group"
            >
              <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center mb-4 group-hover:bg-[#F6C344] transition-colors">
                <i className={`${s.icon} text-white group-hover:text-[#1A365D] transition-colors text-lg`}></i>
              </div>
              <h3 className="font-serif text-base font-bold text-[#1A365D] mb-2">{s.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}